import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import { X, Plus } from 'lucide-react';
import React from 'react'
import styles from '../AdminPanelPage.module.scss'

const CreatePrivatePointForm = ({ modalPayload = {}, setModalPayload = () => {}, closeModal = () => {}, createPrivatePoint, loadPrivatePoints = async () => {}, notifySuccess = () => {}, notifyError = () => {} }) => {
  useInterfaceLanguage();
  return (
    <>
      <label>{tr("Название соц.объекта или МСУ")}</label>
      <input placeholder={tr("Название")} value={modalPayload.name || ''} onChange={(e) => setModalPayload(p => ({ ...p, name: e.target.value }))} />
      <label>{tr("Телефон")}</label>
      <input placeholder={tr("Телефон")} value={modalPayload.phone || ''} onChange={(e) => setModalPayload(p => ({ ...p, phone: e.target.value }))} />
      <label>{tr("Геолокация (широта,долгота)")}</label>
      <input placeholder="42.8746,74.5698" value={modalPayload.geo || ''} onChange={(e) => setModalPayload(p => ({ ...p, geo: e.target.value }))} />
      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={() => { closeModal() }} className={styles.btn_pin_close}><X size={14} aria-hidden="true"/>{tr(" Отмена")}</button>
        <button onClick={async () => {
          try { await createPrivatePoint(modalPayload); await loadPrivatePoints(); closeModal(); notifySuccess(tr("Частная точка создана")) } catch (err) { console.error(err); notifyError(err, tr("Не удалось создать частную точку")) }
        }} className={styles.btn_pin}><Plus size={14} aria-hidden="true"/>{tr(" Создать")}</button>
      </div>
    </>
  )
}

export default CreatePrivatePointForm
